export default __webpack_public_path__ + "static/media/star.24c91962.svg";